import { render, staticRenderFns } from "./packdetail.vue?vue&type=template&id=69c0be62&"
import script from "./packdetail.vue?vue&type=script&lang=js&"
export * from "./packdetail.vue?vue&type=script&lang=js&"
import style0 from "./packdetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports